import { render, staticRenderFns } from "./TickerAdminEditPortfolio.vue?vue&type=template&id=2899ec3e"
import script from "./TickerAdminEditPortfolio.vue?vue&type=script&lang=js"
export * from "./TickerAdminEditPortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports